import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { t } from 'Locale/index';
import { Button, Checkbox, Hr } from 'LocalGluons/index';

import { Device, getActualWidth } from 'DeviceUtils';
import { useStore } from 'Store';
import storeActions from 'Store/storeActions';

import defaultStyles from './PageStyles.jss';

const ChangeUsernameQuestion = ({ onSubmitted, onCancel }) => {
    const { deviceStorageDispatch } = useStore();

    const onDoNotShowAgainPress = () => {
        deviceStorageDispatch({ type: storeActions.setShowEnforceChangePassword, payload: false });
    };

    return (
        <View style={defaultStyles.container}>
            <View style={defaultStyles.titleContainer}>
                <Text style={defaultStyles.title}>{t('SETTINGS.CHANGE_USERNAME_AND_PSW')}</Text>
            </View>
            <Hr />
            <Text style={defaultStyles.description}>
                {t('SETTINGS.CHANGE_USERNAME_AND_PSW_TXT')}
            </Text>
            <View style={defaultStyles.buttonsContainer}>
                <Button
                    style={{
                        button: defaultStyles.button
                    }}
                    title={t('COMMON.CHANGE_NOW')}
                    onPress={onSubmitted}
                />
                <Button
                    style={{
                        button: defaultStyles.button
                    }}
                    isSecondary
                    title={t('COMMON.CHANGE_LATER_IN_SETTINGS')}
                    onPress={onCancel}
                />
                {Device.isPhone && (
                    <View style={defaultStyles.checkBoxContainer}>
                        <Checkbox
                            style={defaultStyles.checkbox}
                            checked={false}
                            onPress={onDoNotShowAgainPress}
                            hitSlop={{
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: getActualWidth()
                            }}
                        />
                        <Text style={defaultStyles.checkBoxText}>
                            {t('COMMON.DO_NOT_SHOW_AGAIN')}
                        </Text>
                    </View>
                )}
            </View>
            {!Device.isPhone && (
                <View style={defaultStyles.checkBoxContainer}>
                    <Checkbox
                        style={defaultStyles.checkbox}
                        checked={false}
                        onPress={onDoNotShowAgainPress}
                        hitSlop={{
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: getActualWidth()
                        }}
                    />
                    <Text style={defaultStyles.checkBoxText}>{t('COMMON.DO_NOT_SHOW_AGAIN')}</Text>
                </View>
            )}
        </View>
    );
};

ChangeUsernameQuestion.propTypes = {
    onSubmitted: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default ChangeUsernameQuestion;
